<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    checked: Boolean,
  },
});
</script>

<template>
  <div class="radio" :class="{ checked }"></div>
</template>

<style>
.radio {
  @apply relative;

  width: 20px;
  height: 20px;

  background: linear-gradient(
    216deg,
    rgba(255, 255, 255, 0.4) -31.97%,
    rgba(255, 255, 255, 0) 114.27%
  );
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.radio.small {
  width: 12px;
  height: 12px;
}

.radio.checked {
  @apply bg-midblue;
  @apply duration-200;
}

.radio::after {
  @apply duration-200;
  content: "";
  position: absolute;
  @apply bg-white;
  border-radius: 50%;
  width: 0;
  height: 0;
  top: 10px;
  left: 10px;
}

.radio.small::after {
  top: 6px;
  left: 6px;
}

.radio.checked::after {
  width: 8px;
  height: 8px;
  top: 5px;
  left: 5px;
}

.radio.checked.small::after {
  width: 4px;
  height: 4px;
  top: 3px;
  left: 3px;
}
</style>
